import { ActivityType } from "@repo/api/client";
import { type ColorName, type IconName } from "@repo/ui";

export const activityMeta: Record<
	ActivityType,
	| {
			icon: IconName;
			color: ColorName;
			label: string;
	  }
	| undefined
> = {
	[ActivityType.Error]: { icon: "AlertCircle", color: "red11", label: "Error" },
	[ActivityType.PriorAuthResult]: {
		icon: "CircleCheckBig",
		color: "amber11",
		label: "Prior auth result",
	},
	[ActivityType.PriorAuthCompleted]: {
		icon: "CircleCheckBig",
		color: "green11",
		label: "Prior-auth completed",
	},
	[ActivityType.EligibilityCheckCompleted]: {
		icon: "ShieldCheck",
		color: "green11",
		label: "Eligibility check completed",
	},
	// Automatically handled by using user profile pic
	[ActivityType.EHRComment]: undefined,
	[ActivityType.Comment]: undefined,
	[ActivityType.ReferralSent]: {
		icon: "ArrowBigRightDash",
		color: "blue11",
		label: "Referral sent",
	},
	[ActivityType.PhoneCall]: {
		icon: "PhoneCall",
		color: "blue11",
		label: "Phone call",
	},
	[ActivityType.ConsentUpdate]: {
		icon: "ShieldEllipsis",
		color: "amber11",
		label: "Consent requested",
	},
	[ActivityType.SpruceMessageSent]: {
		icon: "Reply",
		color: "blue11",
		label: "Sent Spruce message",
	},
	[ActivityType.SpruceMessageReceived]: {
		icon: "Inbox",
		color: "accent11",
		label: "Received Spruce message",
	},
	[ActivityType.SpruceInternalNote]: {
		icon: "FileText",
		color: "amber11",
		label: "Spruce internal note",
	},
	[ActivityType.SearchProviders]: {
		icon: "Search",
		color: "accent11",
		label: "Searched for providers",
	},
	[ActivityType.Unsnooze]: {
		icon: "AlarmClock",
		color: "blue11",
		label: "Unsnoozed",
	},
	[ActivityType.ReassignToUser]: {
		icon: "UserPen",
		color: "blue11",
		label: "Reassigned to user",
	},
	[ActivityType.ReassignToAgent]: {
		icon: "Bot",
		color: "accent11",
		label: "Assigned to agent",
	},
	[ActivityType.Snooze]: {
		icon: "AlarmClock",
		color: "sand11",
		label: "Snoozed",
	},
	[ActivityType.TaskCompleted]: {
		icon: "CircleCheckBig",
		color: "green11",
		label: "Task completed",
	},
};
